// 3스텝 위저드 순수 헬퍼 — 잡 상태(서버 생명주기)와 화면 스텝을 분리한다.
// DONE=분류 완료일 뿐 검토·다운로드 완료가 아니므로 자동으로 EXPORT 에 보내지 않는다.
export const STEP = {
  SOURCE: "source",
  CLASSIFY: "classify",
  EXPORT: "export",
};
const VALID = new Set(Object.values(STEP));

/** 잡 상태 → 기본 진입 스텝. null(파일 초안·선택 전)/RECEIVED=원본, 그 외=분류. */
export function defaultStepFor(status) {
  return status == null || status === "RECEIVED" ? STEP.SOURCE : STEP.CLASSIFY;
}

/** 탭 활성 여부. 원본=항상, 분류=잡 실행 이후, 다운로드=DONE+원본 보존시. */
export function stepEnabled(step, { status, hasSource, hasResults } = {}) {
  if (step === STEP.SOURCE) return true;
  if (step === STEP.CLASSIFY) return status != null && status !== "RECEIVED";
  if (step === STEP.EXPORT) return status === "DONE" && !!hasSource;
  return false;
}

/** 원본 편집 가능 = 파일 초안(잡 생성 전)뿐 — 실행 후 변경은 dedup·결과 idx 정합을 깬다. */
export function sourceEditable(status) {
  return status == null;
}

/** location.search → 스텝 파라미터(유효값만). */
export function readStepParam(search) {
  const v = new URLSearchParams(search || "").get("step");
  return VALID.has(v) ? v : null;
}
